import React, {Fragment} from 'react'
import style from '../scss/components/Header.module.scss'
import styleMain from '../scss/Main.module.scss'
import Button from './Button'
import shadowImg from '../assets/shadow.png'
import shadowImg2x from '../assets/shadow@2x.png'
import shadowImg3x from '../assets/shadow@3x.png'
import { Fade } from "react-awesome-reveal"
import VideoPlayer from "./VideoPlayer"
import {RootStateOrAny, useDispatch, useSelector} from "react-redux"
import {pauseHeaderVideo, playHeaderVideo} from "../actions/videoPlayer"

const Header = () => {
    const videoUrl = 'https://vimeo.com/683742553/d7d21afc93'
    const dispatch = useDispatch()
    const playing: boolean = useSelector((state: RootStateOrAny) => state.videoPlayer.header_video_playing)
    const paused: boolean = useSelector((state: RootStateOrAny) => state.videoPlayer.header_video_paused)
    const playVideo = () => dispatch(playHeaderVideo(true))
    const pauseVideo = () => dispatch(pauseHeaderVideo(true))

    return (
        <Fragment>
            <div className={style.Wrapper}>
                <div className={style.Main}>
                    <Fade direction={'left'} triggerOnce={true}>
                        <img src={shadowImg}
                             srcSet={`${shadowImg2x} 2x, ${shadowImg3x} 3x`}
                             alt={''}
                             className={style.Shadow}
                        />
                    </Fade>
                    <div className={styleMain.Container}>
                        <div className={style.Navigation}>
                            <Fade direction={'down'} triggerOnce={true}>
                                <div className={style.Logo}>
                                    SalonSecrets
                                </div>
                                <div className={style.RightSide}>
                                    <Button onClick={() => window.location.href = '#offer'}>
                                        Osalen SalonSecretsi koolitusel
                                    </Button>
                                </div>
                            </Fade>
                        </div>
                        <div className={style.Container}>
                            <Fade triggerOnce={true}>
                                <strong>KIIRTEE SINU SALONGI UUE TASEMENI</strong>
                            </Fade>
                            <Fade direction={'down'} delay={250} triggerOnce={true}>
                                <h1>
                                    Kas oled valmis oma <strong>salongielu</strong> päriselt paremaks muutma?
                                </h1>
                            </Fade>
                            <Fade direction={'up'} delay={250} triggerOnce={true}>
                                <p>
                                    Populaarseim ilutegijate müügi- ja turunduskoolitus.<br/>
                                    Nüüd saadaval ka veebikursusena!
                                </p>
                            </Fade>
                            <Fade direction={'up'} delay={500} triggerOnce={true}>
                                <Button inverted={true} className={styleMain.MarginBottom52} onClick={() => window.location.href = '#offer'}>
                                    Jah, soovin ligipääsu koolitusele!
                                </Button>
                            </Fade>
                        </div>
                        <div className={style.Placeholder}>
                            <div className={style.Spacing}/>
                        </div>
                    </div>
                </div>
                <Fade direction={'up'} delay={250} triggerOnce={true}>
                    <div className={style.VideoWrapper}>
                        <VideoPlayer
                            url={videoUrl}
                            placeholderVideoUrl={'/salonsecrets/video/header.mp4'}
                            playing={playing}
                            paused={paused}
                            onVideoPlay={playVideo}
                            onVideoPause={pauseVideo}
                        />
                    </div>
                </Fade>
            </div>
        </Fragment>
    )
}

export default Header
